import { useSettings } from "@/context/SettingsContext";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQ() {
  const { settings } = useSettings();
  const faq = settings.faq || [];
  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6">
      <div className="text-center">
        <p className="label-accent text-kys-accent">Questions</p>
        <h1 className="mt-3 font-serif text-4xl tracking-tight text-kys-ink sm:text-5xl">Frequently Asked</h1>
      </div>
      <Accordion type="single" collapsible className="mt-10 space-y-3">
        {faq.map((item, i) => (
          <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-${i}`} className="rounded-md border border-kys-blush-border bg-white px-5">
            <AccordionTrigger className="text-left font-medium text-kys-ink hover:no-underline">{item.q}</AccordionTrigger>
            <AccordionContent className="text-sm leading-relaxed text-kys-charcoal">{item.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
